module.exports = __webpack_public_path__ + "static/media/bg_Image.afe5b176.jpg";